<template>
  <div class="add-funds">
    <img :src="img" alt class="logo" />
    <h2 id="title-funds">{{ $t("addFounds.title") }}</h2>

    <!-- <div class="alert" style="padding: 2rem; gap: .5rem; background: #f5f8ff; border: 1px solid #528bff; width: 95%; max-width: 650px; border-radius: .5rem; margin-bottom: 40px;">
      <h2 style="margin-bottom: 15px;">{{ $t("addFounds.alertTitle") }}</h2>
      <p>{{ $t("addFounds.alertDesc") }}</p>
      <br>
      <ul style="padding-left: 2rem; padding-right: 2rem;" :style="{ direction: language === 'ar' ? 'rtl' : 'ltr' }">
        <li><strong>USDT-TRC Network:</strong> TLSnx6uuVd3fNQ8LeqNU67ckLjfwxTWJrG</li>
        <li><strong>USDT/USDC/ETH-ERC Network:</strong> 0x844BfC6714eF2Cffeb5Bc449BB01A4B71303C66E</li>
        <li><strong>BTC:</strong> 1Gxz76ukwqXFfGwwwU4Q9nqi4PN27VoBE9</li>
      </ul>
      <br>
      <p>{{ $t("addFounds.alertNote") }} <a href="mailto:ar@tvmarkets.com" style="text-decoration: underline; color: #363636;">ar@tvmarkets.com</a></p>
    </div> -->

    <div v-if="iframeLink" class="responsive-iframe-container">
      <Preloader :showModal="loading"></Preloader>
      <iframe
        :src="iframeLink"
        frameborder="0"
        class="responsive-iframe"
        @load="handleIframeLoad"
        v-show="!loading"
    >
    </iframe>
    </div>

    <div class="options" v-show="showOptions">
      <!-- PLatform -->
      <input
        class="cabinet-input"
        :placeholder="this.$t('addFounds.firstname')"
        type="text"
        v-model="firstname"
      />
      <input
        class="cabinet-input"
        :placeholder="this.$t('addFounds.firstname')"
        type="text"
        v-model="lastname"
      />
      <!-- <input
        class="cabinet-input"
        type="email"
        placeholder="Email"
        v-model="email"
      /> -->
      <CustomSelector
        v-model="platform"
        :placeholder="this.$t('addFounds.platform')"
        :options="platforms"
      ></CustomSelector>
      <CustomSelector
        v-model="account"
        :placeholder="this.$t('addFounds.account')"
        :options="sources"
      ></CustomSelector>
      <CustomSelector
        v-model="currency"
        :placeholder="this.$t('addFounds.currency')"
        :options="currencies"
      ></CustomSelector>
      <input
        class="cabinet-input"
        type="number"
        :placeholder="rangeText"
        v-model="amount"
        @blur="focusOut(amount)"
      />

      <div v-if="moreOptions">
        <input
          class="cabinet-input"
          type="email"
          placeholder="Email"
          v-model="email"
        />
      </div>

      <!-- <label>
        {{ $t("addFounds.dob") }}
      </label>

      <input
        class="cabinet-input"
        :placeholder="this.$t('addFounds.firstname')"
        type="date"
        v-model="dob"
        max="2006-12-31"
      /> -->

      <label class="input-checkbox checkBox">
        * {{ $t("addFounds.checkmark") }}
        <input type="checkbox" v-model="checkbox" />
        <span class="checkmark"></span>
      </label>

      <p class="disclaimer">
        {{ $t("addFounds.disclaimer") }}
      </p>
    </div>

    <!-- Button hidden to iframes -->
    <button v-if="!iframeLink" class="red-button" @click="transfer" :disabled="allow">
      {{ $t("addFounds.fund") }} 
    </button>

    <button class="cabinet-back" @click="back">
      <div class="icon"></div>
      {{ $t("addFounds.back") }}
    </button>
  </div>
  <Modal
    v-if="redirectModal"
    @close="redirectModal = false"
    dialogStyle="login-modal"
  >
    <template #header>
      <h3>{{ $t("addFounds.redi") }}</h3>
    </template>
    <template #body>
      <p>{{ $t("addFounds.redirection") }} {{ redirecting }}</p>
    </template>
  </Modal>
  <Modal v-if="showModalZotapay" dialogStyle="login-modal">
    <template #header>
      <h3>{{ $t("addFounds.redi") }}</h3>
    </template>
    <template #body>
      <div class="modal-zotapay">
        <div>
          <div class="application-form-input checkbox-input">
            <div class="application-form-input__col none-border">
              <div class="application-form-input__col__content-check">
                <label
                  class="input-checkbox large"
                  :class="{ invalidform: valid }"
                >
                  <input
                    name="purposeAccount"
                    type="checkbox"
                    value="hedging"
                    @change="valid = false"
                    v-model="agree"
                  />
                  <span class="checkmark"></span>{{ $t("addFounds.checkmark") }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <button class="btnClose" @click="closeModalZotapay()">
          {{ $t("addFounds.submit") }}
        </button>
      </div>
    </template>
  </Modal>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";

import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";

import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";
import { computed } from "@vue/reactivity";
import axios from "axios";
import Modal from "@/components/Modal";
import Preloader from "@/components/Preloader";
import { i18n } from "@/plugins/i18n";

export default {
  name: "AddFunds",
  components: {
    CustomSelector,
    Modal,
    Preloader,
  },
  setup() {
    let img = ref(null);
    let account = ref(null);
    let target = ref([]);
    let sources = ref([]);
    let currency = ref(null);
    let range = ref(null);
    let currencies = ref([]);
    let ranges = ref([]);
    let amount = ref(100);
    let firstname = ref("");
    let lastname = ref("");
    let email = ref(null);
    // let dob = ref(null);
    let showM = ref(false);
    let redirecting = ref(null);
    let method = ref("");
    let busy = ref(false);
    let moreOptions = ref(false);
    let redirectModal = ref(false);
    let platform = ref("");
    let accountsLive = ref([]);
    let showModalZotapay = ref(false);
    let agree = ref(false);
    let valid = ref(false);
    let rangeMin = ref(0)
    let rangeMax = ref(0)
    let viewCheckBox = ref(false);
    let checkbox = ref(false);
    let platforms = ref([
      {
        value: "mt4",
        text: "MetaTrader 4",
      },
      {
        value: "mt5",
        text: "MetaTrader 5",
      },
    ]);
    let rangeText = ref("");
    let status_user = ref("");
    let accounts = ref([]);
    let accountsNumber = ref(null);
    let iframeLink = ref("");
    let cardBrand = ref(null);
    let botonActive = ref(false);
    const loading = ref(true);

    const language = i18n.global.locale;

    let showOptions = ref(false)

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const route = useRoute();

    onMounted(() => {

      console.log('====================================');
      console.log(language);
      console.log('====================================');
      iframeLink.value = localStorage.getItem("urlDepositMethod");

      console.log(iframeLink.value);
      if (!iframeLink.value) {
        let platforms_pay_storage = JSON.parse(localStorage.getItem("DepositMethods"));
        method.value = route.params.target;

        let currency_platform = platforms_pay_storage.alternative[method.value].currency;
        for (let cur in currency_platform) {
          currencies.value.push({
            text: currency_platform[cur],
            value: currency_platform[cur],
          });
        }
        let range_alternative = platforms_pay_storage.alternative[method.value].amount_range;
        rangeMin.value = range_alternative[0]
        rangeMax.value = range_alternative[1]

        let userData = store.state.user;
        firstname.value = userData.firstName;
        lastname.value = userData.lastName;
        if (method.value === 'shift') {
          showOptions.value = true
        }

      }
      let platforms_pay = JSON.parse(localStorage.getItem("platforms_pay"))
      window.addEventListener("keydown", reset);
      emitter.on("userUpdated", () => {
        load();
      });
      emitter.on("preferencesUpdated", () => {
        imgSite();
      });

      imgSite();
      load();
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", reset);
      emitter.off("userUpdated");
      emitter.off("preferencesUpdated");
    });

    const focusOut = (nuevoValor) => {
      if ((nuevoValor < parseInt(rangeMin.value)) || (nuevoValor > parseInt(rangeMax.value))){
        emitter.emit("showDialog", "Amount not valid min " + parseInt(rangeMin.value) + " max " + parseInt(rangeMax.value));
      }
    }

    const formatDateToDDMMYYYY = (isoDate) => {
      if (!isoDate) return "";
      const [year, month, day] = isoDate.split("-");
      return `${day}-${month}-${year}`;
    }

    const handleIframeLoad = () => {
      loading.value = false; // Establece loading en false cuando el iframe se ha cargado
    };
        
    const load = async() => {

      method.value = route.params.target;

      let userInfo;
      userInfo = store.state.user;

      if (!store.state.user) {
        return;
      }

      if (method.value == "UPHOLD" || method.value == "ZOTAPAY" || method.value == "ECOMMPAY") {
        busy.value = true;
        var element = document.getElementById("title-funds");
        // removing everything inside the node
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
        // appending new text node
        element.appendChild(
          document.createTextNode(i18n.global.t("credit.subTitleAdd"))
        );
      }

      if ( method.value === "ZOTAPAY") {
        viewCheckBox.value = true;
      }
    };

    const allow = computed(() => {
      let platformDefined = platform.value !== null && platform.value !== "";
      let targetDefined = account.value !== null;
      let currencyDefined = currency.value !== null && currency.value !== 0;
      let amountDefined =
        amount.value !== null ;
      // let dobDefined = dob.value !== null;
      let checkBox = checkbox.value !== null && checkbox.value !== false;

      if (
        platformDefined &&
        targetDefined &&
        currencyDefined &&
        amountDefined &&
        // dobDefined &&
        checkBox &&
        route.params.target === "shift"
      ) {
        return false;
      } else {
        return true;
      }
    });

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const transfer = () => {
      if (amount.value < rangeMin.value || amount.value > rangeMax.value) {
        emitter.emit("showDialog", "Amount not valid (Min. " + parseInt(rangeMin.value) + " Max. " + parseInt(rangeMax.value));
        return false
      }

      method.value = route.params.target;

      if ( method.value === "ZOTAPAY" && !agree.value) {
        showModalZotapay.value = true;
        return false;
      }

      // const dobFormatted = dob.value ? formatDateToDDMMYYYY(dob.value) : null;
      // console.log(dobFormatted);
      

      showM.value = true;

      const _body = {
        firstname: firstname.value,
        lastname: lastname.value,
        // dob: dobFormatted,
        //customer_email: email.value,
        amount: amount.value,
        trading_account: account.value,
        currency: currency.value,
        platform: platform.value,
        //tradeViewpolicy: checkbox.value,
        //cardBrand: cardBrand.value,
      };

      busy.value = true;

      let _url = ''

      if (method.value === 'shift') {
        _url = process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment-alternative/shift"
      }else{
        _url = process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment-alternative/" + method.value;
      }
      
      const _headers = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": "Bearer " + store.state.token,
        "X-Api-Key": process.env.VUE_APP_X_API_KEY,
      };

      axios({ method: "POST", url: _url, data: _body, headers: _headers })
        .then((result) => {
          setTimeout(() => {
            showM.value = false;
          }, 6000);

          console.log(result);
          busy.value = false;
          amount.value = null;
          console.log(JSON.parse(result.data.response.body));
          const responseObject = JSON.parse(result.data.response.body);
          const paymentUrl = responseObject.payment_url;
          window.location.href = paymentUrl;
        })
        .catch((error) => {
          showM.value = false;
          busy.value = false;
          emitter.emit("showDialog", "Error. Please Contact Tradeview Support");
          console.log(error);
        });
    };

    const imgSite = () => {
      if (store.state.preferences !== null) {
        let theme = store.state.preferences.theme;
        let curr = [];
        switch (route.params.target) {
          case "SKRILL":
            img.value = "/assets/images/logo_skrill.svg";
            curr = [
              {
                text: "USD",
                value: "USD",
              },
              {
                text: "EUR",
                value: "EUR",
              },
            ];
            // currencies.value = curr
            moreOptions.value = true;
            break;
          case "NETELLER":
            img.value = "/assets/images/logo_neteller.svg";
            curr = [
              {
                text: "USD",
                value: "USD",
              },
              {
                text: "EUR",
                value: "EUR",
              },
              // {
              //   text: 'JPY',
              //   value: 'JPY'
              // },
              // {
              //   text: 'CAD',
              //   value: 'CAD'
              // },
              // {
              //   text: 'GBP',
              //   value: 'GBP'
              // }
            ];
            // currencies.value = curr
            moreOptions.value = true;
            break;
          case "ZOTAPAY":
            if (theme === "LIGHT") {
              img.value = "/assets/images/logo_zotapay_light.svg";
            }
            if (theme === "DARK") {
              img.value = "/assets/images/logo_zotapay.svg";
            }
            curr = [
              {
                text: "USD",
                value: "USD",
              },
              {
                text: "EUR",
                value: "EUR",
              },
            ];
            // currencies.value = curr
            moreOptions.value = true;
            break;
          case "ECOMMPAY":
            img.value = "/assets/images/logo_ecommpay.svg";
            curr = [
              {
                text: "USD",
                value: "USD",
              },
              {
                text: "EUR",
                value: "EUR",
              },
              // {
              //   text: 'GBP',
              //   value: 'GBP'
              // },
              // {
              //   text: 'RUB',
              //   value: 'RUB'
              // }
            ];
            // currencies.value = curr
            break;
          case "UPHOLD":
            img.value = "/assets/images/logo_uphold.svg";
            curr = [
              // {
              //   text: 'AUD',
              //   value: 'AUD'
              // },
              // {
              //   text: 'BTC',
              //   value: 'BTC'
              // },
              // {
              //   text: 'BCH',
              //   value: 'BCH'
              // },
              // {
              //   text: 'CAD',
              //   value: 'CAD'
              // },
              // {
              //   text: 'CHF',
              //   value: 'CHF'
              // },
              // {
              //   text: 'ETH',
              //   value: 'ETH'
              // },
              {
                text: "EUR",
                value: "EUR",
              },
              // {
              //   text: 'GBP',
              //   value: 'GBP'
              // },
              // {
              //   text: 'JPY',
              //   value: 'JPY'
              // },
              // {
              //   text: 'LTC',
              //   value: 'LTC'
              // },
              // {
              //   text: 'MXN',
              //   value: 'MXN'
              // },
              {
                text: "USD",
                value: "USD",
              },
              // {
              //   text: 'XRP',
              //   value: 'XRP'
              // }
            ];
            // currencies.value = curr
            break;
          // case 'TRONIPAY':
          //   img.value = '/assets/images/logo_tronipay.svg';
          //   break
          // case 'BITPAY':
          //   img.value = '/assets/images/logo_bitpay.svg';
          //   if (theme === 'LIGHT') {
          //     img.value = '/assets/images/logo_bitpay_light.svg';
          //   }
          //   if (theme === 'DARK') {
          //     img.value = '/assets/images/logo_bitpay.svg';
          //   }
          //   break
          // case 'PAYR':
          //   img.value = '/assets/images/logo_payretailers.svg';
          //   break
          // case 'STICPAY':
          //   img.value = '/assets/images/logo_sticpay.svg';
          //   break
          // case 'FASAPAY':
          //   img.value = '/assets/images/logo_fasapay.svg';
          //   break
          // case 'ADVCASH':
          //   img.value = '/assets/images/logo_advcash.svg';
          //   break
          // case 'TRANSFERMATE':
          //   if (theme === 'LIGHT') {
          //     img.value = '/assets/images/logo_transfermate_light.svg';
          //   }
          //   if (theme === 'DARK') {
          //     img.value = '/assets/images/logo_transfermate.svg';
          //   }
          //   break
          // case 'PAYTRUST':
          //   img.value = '/assets/images/logo_paytrust.svg';
          //   break
        }
      }
    };

    const back = () => {
      router.go(-1);
    };

    const reset = (e) => {
      if (e.key === "Escape") {
        account.value = null;
        currency.value = null;
        amount.value = null;
      }
    };

    const closeModalZotapay = () => {
      if (agree.value) {
        showModalZotapay.value = false;
        transfer();
      } else {
        valid.value = true;
      }
    };

    watch(platform, () => {
      sources.value = [];
      let platforChange = "";
      if (platform.value == "mt4") {
        platforChange = "mt4checkaccounts";
        accounts.value = JSON.parse(localStorage.getItem("Accountslv4"));
      }
      if (platform.value == "mt5") {
        platforChange = "mt5checkaccounts";
        accounts.value = JSON.parse(localStorage.getItem("Accountslv5"));
      }
      status_user.value = localStorage.getItem("activeAccount");
      if (
        status_user.value == "AT_DETAILS" ||
        status_user.value == "PENDING_VALIDATION"
      ) {
        emitter.emit("showDialog", i18n.global.t("accounts.dialogShowFive"));
      } else {
        // disabledBtn.value = true;
        // showM.value = false;
        if (accounts != null) {
          console.log(accounts.value);
          accountsNumber.value = accounts;
          accounts.value.forEach((row) => {
            sources.value.push({
              value: row.login,
              text: row.login,
            });
          });
          console.log(sources);
          disabledBtn.value = false;
        }
      }
    });

    watch();
    return {
      busy,
      allow,
      img,
      account,
      accounts,
      target,
      currency,
      currencies,
      range,
      ranges,
      email,
      firstname,
      lastname,
      // dob,
      cardBrand,
      amount,
      sources,
      showM,
      back,
      reset,
      transfer,
      imgSite,
      moreOptions,
      redirecting,
      redirectModal,
      platform,
      accountsLive,
      platforms,
      showModalZotapay,
      agree,
      valid,
      closeModalZotapay,
      viewCheckBox,
      checkbox,
      iframeLink,
      rangeText,
      method,
      rangeMin,
      rangeMax,
      botonActive,
      language,
      loading,
      handleIframeLoad,
      focusOut,
      showOptions,
      formatDateToDDMMYYYY
    };
  },
};
</script>

<style scoped>
.responsive-iframe-container {
  width: 70%;
  height: 70%;
  height: 500px;
  min-width: 320px;
  max-width: 800px;
}

.responsive-iframe {
  width: 100%;
  height: 100%;
}
</style>
